import { combineReducers } from 'redux';
import FillWord from './reducers/fillword';

export default combineReducers({
  FillWord
})